import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import PrimeToastProvider from "../src/components/common/toast-provider";
import reportWebVitals from "./reportWebVitals";

import "./index.css";
import "./assets/css/global.css";
import "./assets/css/login.css";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/saga-blue/theme.css";

import App from "./App";
import { messaging } from "./firebase/firebase-config";
import { onMessage } from "firebase/messaging";

// Requesting the FCM token (which requests browser notification permission)
// now happens in App.tsx, gated on an actual logged-in admin session — see
// the comment there. This bundle also serves the public site, where every
// anonymous visitor was getting an unsolicited permission prompt on load.

// 🔹 Handle Foreground Notifications
onMessage(messaging, (payload) => {
  console.log("📩 Foreground message received:", payload);

  // ✅ Only show notification if using `data` payload
  if (payload.data) {
    new Notification(payload.data.title, {
      body: payload.data.body,
      icon: "/app-icon.png",
      badge: "/app-icon.png"
    });
  }
});

// 🔹 Register Service Worker for Background Notifications
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js", { scope: "/" }) // Ensure correct scope
      .then((registration) => {
        console.log("✅ Service Worker registered successfully:", registration);
      })
      .catch((error) => {
        console.error("❌ Service Worker registration failed:", error);
      });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <Router>
        <PrimeToastProvider>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </Provider>
        </PrimeToastProvider>
      </Router>
    </PrimeReactProvider>
  </React.StrictMode>
);

reportWebVitals();
